class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');

    this._onScrollToCloseHeaderSearch = this._onScrollToCloseHeaderSearch.bind(this);
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  /** Close header search when the page scrolls; ignore scroll inside the modal (e.g. predictive results). */
  _onScrollToCloseHeaderSearch(event) {
    if (!this.isOpen()) return;
    const t = event.target;
    if (t instanceof Element && this.contains(t)) return;
    this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    if (this.classList.contains('header__search')) {
      document.addEventListener('scroll', this._onScrollToCloseHeaderSearch, { capture: true, passive: true });
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (this.classList.contains('header__search')) {
      document.removeEventListener('scroll', this._onScrollToCloseHeaderSearch, { capture: true });
    }
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (this.classList.contains('header__search')) {
      document.body.dispatchEvent(new CustomEvent('phe:header-search-closed'));
    }
  }
}

customElements.define('details-modal', DetailsModal);
